import styled, { css } from 'styled-components'
import { phoneMaxWidth, fontSize } from '../../DashboardSettings.styles'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'

export const Content = styled.div`
  max-width: ${props => props.isParent ? '675px' : '915px'};
  margin: 15px auto 0;
  padding-top: 20px;

  @media (max-width: 950px) {
    max-width: ${props => props.isParent ? '591px' : '731px'};
  }

  @media (max-width: ${phoneMaxWidth}px) {
    margin: 0px auto;
    padding-top: 0px;
  }
`

export const Header = styled.div`
  padding-top: 20px;
`

export const LargeTitle = styled.h1`
  font-size: ${fontSize.xLarge};
  color: ${colors.darkPurple};
  margin-top: 0px;
  margin-bottom: 15px;
`

export const SmallTitle = styled.h2`
  font-size: 15px;
  color: ${colors.pink};
  margin-top: 0px;
  margin-bottom: 15px;
`

export const Subtitle = styled.h3`
  font-size: ${fontSize.medium};
  font-weight: normal;
  color: ${colors.white};
  margin-top: 0px;
  margin-bottom: 0px;
`

export const InfoText = styled.p`
  font-size: ${fontSize.small};
  color: ${colors.darkTeal};
  position: relative;
  margin-left: 34px;

  &:before {
    content: 'i';
    font-weight: bold;
    position: absolute;
    left: -34px;
    top: -4px;
    border: 1px solid;
    border-radius: 50%;
    padding: 2px 10px;
  }
`

export const ClassControlsButton = styled.div`
  color: #237C64;
  font-size: 15px;
  margin-top: 16px;
  margin-bottom: 16px;
`
